import React, { useEffect, useRef, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import '@coreui/coreui/dist/css/coreui.min.css'
import { useLocation, useNavigate } from "react-router-dom";
import { ref, getDownloadURL } from "firebase/storage";
import db, { storage } from "../../firebase/firebaseConfig";
import { useMemo } from "react";
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { useLoading } from "../Loading";
import { useAuth } from "../../contexts/authContext";
import { display } from "@mui/system";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';

const LostFound = () => {
  const [pets, setPets] = useState([]);
  const { setLoading } = useLoading();
  const { currentUser } = useAuth();
  const malaysiaStates = [
    "Johor",
    "Kedah",
    "Kelantan",
    "Malacca",
    "Negeri Sembilan",
    "Pahang",
    "Perak",
    "Perlis",
    "Penang",
    "Sabah",
    "Sarawak",
    "Selangor",
    "Terengganu",
    "Kuala Lumpur",
  ];
  const [isExpanded, setIsExpanded] = useState(false);
  const collapseRef = useRef(null);

  useEffect(() => {
    const collapseElement = collapseRef.current;
    if (collapseElement) {
      const collapseInstance = new window.coreui.Collapse(collapseElement, {
        toggle: false // Prevent automatic toggling by the button initially
      });

      if (isExpanded) {
        collapseInstance.show();
      } else {
        collapseInstance.hide();
      }
    }
  }, [isExpanded]);

  const handleButtonClick = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    const fetchPets = async () => {
      const petCollection = query(collection(db, "LostFound"), where("status", "!=", "Completed"));

      const unsubscribeLostFound = onSnapshot(petCollection, (petSnapshot) => {
        const petList = petSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const sortedPetList = [...petList].sort((a, b) => {
          if (a.createdAt === null) return 1; // null timestamps go last
          if (b.createdAt === null) return -1;
          return b.createdAt - a.createdAt; // Sort descending (newest first)
        });
        setPets(sortedPetList);
      }, (error) => {
        console.error(error);
      })


      return () => unsubscribeLostFound();
    };

    fetchPets();
  }, []);


  const navigate = useNavigate();
  const location = useLocation();
  const [filters, setFilters] = useState({
    petType: location?.state?.petType || "all",
    state: "all",
    status: "all"
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  //useMemo to prevent unnecessary re-computation.
  const filteredPets = useMemo(() => {
    return pets.filter((pet) => {
      return (
        (filters.petType === "all" || pet.petType === filters.petType) &&
        (filters.state === "all" || pet.location === filters.state) &&
        (filters.status === "all" || pet.status === filters.status)
      );
    });
  }, [pets, filters]);

  const [imageUrls, setImageUrls] = useState({});

  useEffect(() => {
    const fetchImages = async () => {
      const urls = {};
      for (let pet of filteredPets) {
        try {
          const imageRef = ref(storage, `LostFound/${pet.image}`);
          const url = await getDownloadURL(imageRef);
          urls[pet.id] = url;
          // const image = await getPetImage(pet.image);

          // urls[pet.id] = image.urls;
        } catch (error) {
          console.error(`Error fetching image for petID ${pet.id}:`, error);
          urls[pet.id] = "/blue.gif"; // Fallback image
        }
      }
      setImageUrls((prev) => {
        const isDifferent = JSON.stringify(prev) !== JSON.stringify(urls);
        return isDifferent ? urls : prev; //avoid keep looping
      });
    };

    fetchImages();
    setLoading(false);
  }, [filteredPets]);

  const handleClearFilters = () => {
    setFilters({
      petType: "all",
      state: "all",
      status: "all"
    })
  }

  const addNewPost = () => {
    navigate("/new-post")
  }

  const [activeStep, setActiveStep] = useState(0);
  const petsPerPage = 8;
  const maxSteps = Math.ceil(filteredPets.length / petsPerPage);
  const startIndex = activeStep * petsPerPage;
  const currentPets = filteredPets.slice(startIndex, startIndex + petsPerPage);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };


  return (
    <div className="lostFoundContainer">

      <div className="filterContainer"  style={{ display: "flex", alignItems: "center", justifyContent: "center"}}>
        
        <div id="collapseExample"
          className={`collapse ${isExpanded ? 'show' : ''} filterList`} style={{marginTop:"1%"}}>
          <div>
            <label htmlFor="petType">Pet Types</label> <br></br>
            <select name="petType" id="petType" className="form-select form-select-sm"
              aria-label="Default select example" value={filters.petType}
              onChange={handleFilterChange}>
              <option value="all">All</option>
              <option value="Dog">Dog</option>
              <option value="Cat">Cat</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div>
            <label htmlFor="state">Location</label> <br></br>
            <select name="state" id="state" className="form-select form-select-sm"
              aria-label="Default select example" value={filters.state}
              onChange={handleFilterChange}>
              <option value="all">All</option>
              {malaysiaStates.map((state, index) => (
                <option key={index} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label htmlFor="status">Status</label> <br></br>
            <select name="status" id="status" className="form-select form-select-sm"
              aria-label="Default select example" value={filters.status}
              onChange={handleFilterChange}>
              <option value="all">All</option>
              <option value="Lost">Lost</option>
              <option value="Found">Found</option>
            </select>
          </div>
          <div className="clearBtnContainer">
            {(filters.petType !== "all" || filters.state !== "all" || filters.status !== "all") && <button onClick={handleClearFilters} className="clearFilterBtn" >
              Clear
            </button>}
          </div>
        </div>
        <div style={{ display: "flex", gap: "10px", alignItems: "flex-end", justifySelf:'right', marginLeft:"auto" }}>
        {currentUser && <button className="newPostBtn" onClick={addNewPost}>Add New Post</button>}
          <button
            type="button"
            data-coreui-toggle="collapse"
            data-coreui-target="#collapseExample"
            onClick={handleButtonClick}
            aria-expanded={isExpanded}
            aria-controls="collapseExample"
            style={{ padding: "5px 20px", background:"none", border: "none"}}
          >
            {isExpanded?<FilterAltOffOutlinedIcon fontSize="large" style={{ marginRight: "5px" }}/>
            :<FilterAltOutlinedIcon fontSize="large" style={{ marginRight: "5px" }} />}Filter
          </button>
         
        </div>
      </div>


      <div className="container-fluid">
        <div className="row row-cols-2 row-cols-md-4 g-4 p-4">

          {currentPets.length !== 0 ? (currentPets.map((pet) => (
            <div className="col">
              <div className="card h-60 p-0 m-0" onClick={() => navigate(`/lost-found-details/${pet.id}`)}>
                <div className="aspect-ratio-square">
                  <img src={imageUrls[pet.id] || "/blue.gif"} className="card-img-top" alt="..." />
                </div>
                <div className="card-body">
                  <h5 className="card-page-title">{pet.petName}</h5>
                  <p className="card-page-text" style={{ marginBottom: "5px" }}>{pet.location}</p>
                  <p className="card-page-text" style={{ margin: "0" }}>{pet.status}</p>
                </div>
              </div>
            </div>
          )))
            :
            (pets.length !== 0 && <p style={{ marginTop: "70px", width: "100%" }}>No results matching your criteria.</p>)
          }
        </div>
      </div>
      <Box sx={{ height: 60, maxWidth: 400, width: '100%', p: 2, margin: "10px" }}>
        <MobileStepper
          sx={{ backgroundColor: "#F8F8F8 !important" }}
          variant="text"
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          nextButton={
            <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1 || maxSteps === 0}>
              Next <KeyboardArrowRight />
            </Button>
          }
          backButton={
            <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
              <KeyboardArrowLeft /> Back
            </Button>
          }
        />
      </Box>
    </div>
  );
};

export default LostFound;
